import styled, { css } from 'styled-components';

const darkHeroTheme = css`
  ${({ scrolled }) => {
    return `
        .white-logo {
            ${
              scrolled
                ? `visibility: hidden;
                    opacity: 0;`
                : `visibility: visible;
                    opacity: 1;`
            }
        }
        .tertiary-logo {
          ${
            scrolled
              ? `visibility: visible;
                    opacity: 1;`
              : `visibility: hidden;
                    opacity: 0;`
          }
        }

        .menu-item--parent-link, a, i {
          ${scrolled ? `color: var(--neutral-7)` : `color: white`};
        }

        @media (max-width: 1240px) {
          .menu-item--parent-link, a, i {
            color: var(--neutral-7) !important;
          }
        }
    `;
  }}
`;

const lightHeroTheme = css`
  a {
    color: var(--neutral-7);
  }
  .white-logo {
    visibility: hidden;
    opacity: 0;
  }
  .tertiary-logo {
    visibility: visible;
    opacity: 1;
  }
`;

const mobileMenuStyles = css`
  position: fixed !important;
  height: 100% !important;
  overflow: auto;
  background: white;
  z-index: 2147483647 !important;
`;

const WebsiteHeaderContainer = styled.div`
  ${({ theme }) => (theme === 'darkHeroHeader' ? darkHeroTheme : lightHeroTheme)};
  z-index: 1000;
  width: 100%;
  background: ${({ background }) => background};
  background: white;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 8px;

  a.website-header--button-cta {
    color: white !important;
  }

  .website-header--announcement-bar {
    margin-top: 0;
    transition: all 0.4s ease-out;
  }

  @media (max-width: 1240px) {
    ${({ mobileMenuOpen }) => mobileMenuOpen && mobileMenuStyles};

    .website-header--main-menu {
      padding: 0 !important;
    }
  }

  @media (min-width: 1240px) {
    &.website-header.top {
      background: transparent;
      position: fixed;
      z-index: 1000;
      animation-name: ${({ $hideAnnouncementBar }) => ($hideAnnouncementBar ? '' : 'slideUp')};
      animation-duration: 0.4s;
      animation-timing-function: ease;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;

      @keyframes slideUp {
        0% {
          transform: translate(0, 0px);
          background: white;
        }
        100% {
          transform: translate(0, 0);
          background: transparent;
        }
      }
    }

    &.website-header.scrolled {
      position: fixed;
      background: white;
      box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08);
      z-index: 1000;
      animation-name: ${({ $hideAnnouncementBar }) => ($hideAnnouncementBar ? '' : 'slideDown')};
      animation-duration: 0.4s;
      animation-timing-function: ease;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;

      @keyframes slideDown {
        0% {
          transform: translate(0, 0);
          background: transparent;
        }
        100% {
          transform: translate(0, 0px);
          background: white;
        }
      }

      .website-header--announcement-bar {
        margin-top: -58px;
      }
    }

    &.website-header.scrolled-2 {
      .website-header--main-menu .website-header--inner-container {
        padding: 0 30px !important;
      }
    }
  }
`;

const WebsiteHeaderInnerContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: 0.2s;
  padding: 15px 30px;
  transition: all 0.4s ease-out;
  background: white;

  .website-header--menu-item {
    display: inline-block;
    vertical-align: middle;
    padding: 0 17px;

    a {
      font-family: Sofia Pro;
      font-size: 16px;
      line-height: 80px;
      transition: none;
      color: black;

      span.anticon-caret-up {
        display: none;
      }
    }
  }

  .st-menu-splitter {
    display: inline-block;
    height: 27.5px;
    width: 1px;
    border-left: 1px solid #b8d3df;
    vertical-align: middle;
  }

  @media (max-width: 1450px) {
    padding: 0 30px !important;
  }

  @media (max-width: 390px) {
    height: 80px;
  }
`;

export { WebsiteHeaderContainer, WebsiteHeaderInnerContainer };
